import { config } from './config'
import loopbackProvider from 'react-admin-loopback'

const createDataProvider = loopbackProvider(config.apiUrl)

export const dataProvider = async (type, resource, params) =>
  await createDataProvider(type, resource, params)
